import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterGripForSaveDto } from '../../api/models';

export type TABLE_TYPE = Table<PutterGripForSaveDto>;

export const TABLE = 'putterGrip';
const SCHEMA = 'putterGripId, sortId';

class PutterGripDatabase implements DataRepository<PutterGripForSaveDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterGripForSaveDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterGripForSaveDto, key: Key): Promise<PutterGripForSaveDto> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterGripForSaveDto[]): Promise<PutterGripForSaveDto[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterGripForSaveDto[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterGripDB = new PutterGripDatabase(db);
